/* 🤖 this file was generated by svg-to-ts */
export const matIconArrowRight: {
  name: 'arrow-right';
  data: string;
} = {
  name: 'arrow-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m10 17 5-5-5-5v10z"/></svg>`
};
